import { Component, Inject } from '@angular/core';
import { MpSnackbarRef } from '../mp-snackbar/mp-snackbar-ref.model';
import { MP_SNACKBAR_DATA, MP_SNACKBAR_REF } from '../mp-snackbar/mp-snackbar.tokens';

@Component({
  selector: 'mp-api-error-message',
  templateUrl: './mp-api-error-message.component.html',
  styleUrls: ['./mp-api-error-message.component.scss']
})
export class MpApiErrorMessageComponent {
  public variable: string[];

  constructor(
      @Inject(MP_SNACKBAR_REF) protected readonly mpSnackbarRef: MpSnackbarRef<MpApiErrorMessageComponent>,
      @Inject(MP_SNACKBAR_DATA) protected readonly data: any
  ) {
    if (data.variable) {
      this.variable = data.variable.toString().split(';');
    }
  }
}
